import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

/**
 * Exporte les données en CSV
 * @param {Array} data - Les données à exporter
 * @param {string} fileName - Le nom du fichier (sans extension)
 */
export const exportToCSV = (data, fileName) => {
    const csv = XLSX.utils.json_to_sheet(data);
    const csvOutput = XLSX.utils.sheet_to_csv(csv);
    const blob = new Blob([csvOutput], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, `${fileName}.csv`);
};

/**
 * Exporte les données en PDF
 * @param {Array} data - Les données à exporter
 * @param {Array} headers - Les en-têtes de colonnes
 * @param {string} fileName - Le nom du fichier (sans extension)
 */
export const exportToPDF = (data, headers, fileName) => {
    const doc = new jsPDF();
    doc.autoTable({
        head: [headers],
        body: data.map(row => headers.map(header => row[header])),
    });
    doc.save(`${fileName}.pdf`);
};

/**
 * Exporte les données en Excel
 * @param {Array} data - Les données à exporter
 * @param {string} fileName - Le nom du fichier (sans extension)
 */
export const exportToExcel = (data, fileName) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
};